import { FaLinkedin } from '../../common/Icons';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const linkedinUrl = "https://www.linkedin.com/in/carles-falc%C3%B3-riera-942758172/";

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-vulnerability-hint">
            Psst... there's a small vulnerability hidden on this page. Found it? Let me know! 😉
          </p>
        </div>
        <div className="footer-right">
          <p className="footer-copyright">
            &copy; {currentYear} Carles Falcó Riera
          </p>
          <a
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Carles Falcó LinkedIn Profile"
            className="footer-linkedin-link"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;